import { createSlice } from "@reduxjs/toolkit";
import { postRequest } from "../../services/apiCaller/cl_index";
import {
    getFromLocalStorage,
    setToLocalStorage,
    trackEvent,
} from "../../services/helper/cl_Helper";
import { endpoints } from "../../api/ApiEndPoints";

const initialState = {
    mobileNumber: "",
    errorMessage: "",
    phoneError: false,
    pinError: false,
    otpSuccess: false,
    resendOtp: false,
    pin: "",
    confirmPin: "",
    loader: false,
    mobileLoader: false,
    resetSuccess: false,
    resetOtpScreen: false,
    isLoading: false,
};

export const resetSlice = createSlice({
    name: "reset",
    initialState,
    reducers: {
        setMobileNumber: (state, action) => {
            state.mobileNumber = action.payload;
        },
        setResetSuccess: (state, action) => {
            state.resetSuccess = action.payload;
        },
        setErrorMessage: (state, action) => {
            state.errorMessage = action.payload;
        },
        setPhoneError: (state, action) => {
            state.phoneError = action.payload;
        },

        setLoader: (state, action) => {
            state.loader = action.payload;
        },
        setMobileLoader: (state, action) => {
            state.mobileLoader = action.payload;
        },
        setResetOtpScreen: (state, action) => {
            state.resetOtpScreen = action.payload;
        },
        setIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
    },
});

export const {
    setMobileNumber,
    setErrorMessage,
    setPhoneError,
    setLoader,
    setMobileLoader,
    setResetSuccess,
    setResetOtpScreen,
    setIsLoading,
} = resetSlice.actions;

export default resetSlice.reducer;

export const handleReset = (mobNum, navigate) => (dispatch) => {
    dispatch(setIsLoading(true));
    let url = endpoints?.resetPin;
    const payload = {
        channelType: "mobile",
        mobileNumber: mobNum,
    };
    postRequest(url, payload)
        .then((res) => {
            if (res?.data?.code === "1000") {
                dispatch(setIsLoading(false));
                dispatch(setResetSuccess(true));
                setToLocalStorage("gt", res.data.result.data.token);
                navigate("/resetotpscreen");
                trackEvent('User', 'pin', 'reset');
            } else {
                dispatch(setIsLoading(false));
                dispatch(setResetSuccess(false));
                dispatch(setErrorMessage(res?.data?.result?.message));
            }
        })
        .catch((err) => {
            dispatch(setIsLoading(false));
        });
};
